import _ from 'lodash-es';
import MarkdownIt from 'markdown-it'
import sanitizeHtml from 'sanitize-html'

export default function (content, options = {}) {
    content = sanitizeHtml(_.escape(content), {
        allowedTags: ['em', 'strong', 'a', 'br'],
        allowedAttributes: {
            a: ['href', 'target'],
        },
        allowedSchemes: ['http', 'https', 'mailto'],
    });

    const md = new MarkdownIt(Object.assign({
        html: false,
        linkify: true,
        typographer: false,
        breaks: true,
    }, options));

    md.disable([
        'blockquote',
        'code',
        'fence',
        'image',
        'list',
        'table',
        'strikethrough',
    ]);

    return md.render(content);
}
